import React from 'react'
import { Popup } from 'semantic-ui-react'

function startOfDay(date) {
  return new Date(date.getFullYear(), date.getMonth(), date.getDate())
}

function birthdayOffset(birthday, anchor) {
  const a = startOfDay(anchor)
  for (const offset of [0, 1, -1]) {
    const candidate = new Date(a.getFullYear(), a.getMonth(), a.getDate() + offset)
    if (candidate.getMonth() === birthday.getMonth() &&
        candidate.getDate()  === birthday.getDate()) {
      return offset
    }
  }
  return null
}

function tooltipText(days, name, anchorIsConsultation) {
  const scope = 'components.patient_birthday_badge'
  if (anchorIsConsultation) {
    if (days === 0) return I18n.t(`${scope}.on_consultation`, { name })
    if (days === 1) return I18n.t(`${scope}.day_after_consultation`, { name })
    return I18n.t(`${scope}.day_before_consultation`, { name })
  }
  if (days === 0) return I18n.t(`${scope}.today`, { name })
  if (days === 1) return I18n.t(`${scope}.tomorrow`, { name })
  return I18n.t(`${scope}.yesterday`, { name })
}

const PatientBirthdayBadge = ({ patient, anchorDate }) => {
  if (!patient || !patient.birthday) return null

  const anchor = anchorDate ? new Date(anchorDate) : new Date()
  const birthday = new Date(patient.birthday)
  if (isNaN(birthday) || isNaN(anchor)) return null

  const days = birthdayOffset(birthday, anchor)
  if (days === null) return null

  const tip = tooltipText(days, patient.firstName, Boolean(anchorDate))

  return (
    <Popup inverted
      trigger={
        <span role='img' aria-label={tip}
          style={{ marginLeft: '0.2em', fontSize: '1.2em', cursor: 'default', }}>
          🎂
        </span>
      }
      content={tip}
      position='top center'
    />
  )
}

export default PatientBirthdayBadge
